<template>
  <div v-if="book" class="masechta-page page-container pt-3 pb-4">
    <div class="card sponsors">
      <div class="title card-header py-2 px-5">
        <div class="row">
          <div class="col-md-4 mb-3 mb-md-0">
            <v-select class="select-filter text-white" v-model="bookRedirect" :placeholder="$_t('KW:masechta')" :options="book.books"></v-select>
          </div>
          <div class="col-md-4 mb-3 mb-md-0">
            <v-select class="select-filter" v-model="filtermagid" :placeholder="$_t('KW:filterByMagidShiur')" :options="book.professors"></v-select>
          </div>
          <div class="col-md-4">
            <v-select class="select-filter" v-model="filterChapter" :placeholder="$_t('KW:jumpToChapter')" :options="chapterFilter"></v-select>
          </div>
          <!-- <div class="col-md-3">
            <v-select class="select-filter" v-model="filterMishna" :placeholder="$_t('KW:jumpToMishna')" :options="mishnaFilter"></v-select>
          </div> -->
        </div>
      </div>
      <div class="card-body bg-lightgray">
        <ul class="list-unstyled m-0 bg-white">
          <template v-if="book.book_sponsors && book.book_sponsors.length > 0" class v-for="sponsor in book.book_sponsors">
            <div class="row">
              <div class="col-md-10">
                <li class="row py-2 text-center text-md-left" v-if="sponsor.dedicated_to">
                  <div class="col-md-7 col-12 dedicated py-3" :class="isRTL ? 'border-left' : 'border-right'">
                    <span v-if="book.multi_volumes" class="badge p-1 bg-dark-blue text-white">{{ $t('volume', { number: sponsor.volume_number }) }}</span>
                    <span class="h5">{{ $t('dedicatedBy') }}</span>
                    <br />
                    <span class="text-primary h4" v-if="sponsor.sponsor && sponsor.sponsor.name">{{ sponsor.sponsor.name }}</span>
                    <span class="text-primary h4" v-else>{{ $t('anonymous') }}</span>
                  </div>
                  <div class="col-md-5 col-12 memory-of pl-md-5">
                    <span class="text-primary h4">{{ sponsor.dedicated_to }}</span>
                  </div>
                </li>
              </div>
            </div>
          </template>
          <div class="text-right mt-3">
            <a
              v-if="book.download_url"
              :href="book.download_url"
              class="btn btn-darkerblue col col-md-auto"
              target="_blank"
              :title="$t('downloadMasechta', { name: book.name })"
              @click.prevent="track(book.download_url)"
            >
              <b-btn variant="outline-secondary" class="py-md-2 px-md-3 text-blue d-flex justify-content-center align-items-center">
                <span>
                  <i class="fa fa-2x fa-download"></i>
                </span>
                <span class>{{ $t('downloadAllMasechta') }}</span>
              </b-btn>
            </a>
            <a
              class="btn btn-darkerblue col col-md-auto"
              v-for="i in 4"
              v-if="book['download_url' + i]"
              :href="book['download_url' + i]"
              target="_blank"
              @click.prevent="track(book['download_url' + i], i)"
              :title="$t('downloadVolMasechta', { name: book.name, vol: i })"
            >
              <b-btn variant="outline-secondary" class="py-md-3 px-md-4 text-blue float-right">
                <i class="fa fa-2x fa-download"></i>
                {{ $t('downloadVol', { num: i }) }}
              </b-btn>
            </a>
          </div>
        </ul>
      </div>
    </div>
    <ul class="list-unstyled mt-5 masechta-list">
      <li class="daf-card mb-4 px-2" v-for="(chapters, index) in filteredMishnas" :id="'mishna-' + index">
        <div v-for="mishnas in chapters">
          <router-link :to="'/shiur/masechta-' + book.url_key + '/perek-' + mishnas[0].mishna_chapter + '/mishna-' + mishnas[0].mishna_number">
            <h5 class="card-header text-white bg-dark-blue">
              <span class="daf-eng">
                {{
                  $t('KW:mishnaShiurTitle', {
                    masechta: mishnas[0].book.name,
                    chapter: mishnas[0].mishna_chapter,
                    mishna: mishnas[0].mishna_number,
                  })
                }}
              </span>
              <span v-if="!isRTL" class="daf-hebrew float-right">
                {{
                  $t('KW:mishnaShiurTitle', {
                    masechta: mishnas[0].book.name_hebrew,
                    chapter: mishnas[0].mishna_chapter,
                    mishna: mishnas[0].mishna_number,
                  })
                }}
              </span>
            </h5>
          </router-link>
          <div class="border">
            <div class="mb-3">
              <div style="font-size: 1.2rem" class="text-center d-block" v-for="shiurim in mishnas">
                <div class="mt-3" v-if="shiurim.sponsor.length > 0">
                  <div>
                    <span class="">{{ $_t('KW:sponsoredByMessageMishna', { names: shiurim.sponsor.map(s => s.name).join(',') }) }}</span>
                  </div>
                  <div v-if="shiurim.dedicated_to">
                    <span>{{ shiurim.dedicated_to }}</span>
                  </div>
                </div>
              </div>
              <mishna :data="mishnas" :chapter="index"></mishna>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import MishnaComponent from './masechta/Mishna';
import VueSelect from 'vue-select';
import { scroller } from 'vue-scrollto/src/scrollTo';
export default {
  metaInfo: function () {
    return {
      title: this.book.name + ' / ' + this.book.name_hebrew,
    };
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'masechta',
  },
  components: {
    Mishna: MishnaComponent,
    vSelect: VueSelect,
  },
  data: function () {
    return {
      filtermagid: null,
      filterChapter: null,
      filterMishna: null,
      loading: false,
      book: { name: null },
      bookRedirect: null,
      mareiMekomos: {
        note: null,
        shiurim: {
          mishna_chapter: null,
          mishna_number: null,
          message: null,
          professor: {
            name: null,
          },
        },
      },
    };
  },
  created: function () {
    this.getData();
    var _this = this;
    this.$root.$on('show_mm_modal', function (value) {
      console.log(value);
      _this.mareiMekomos = value;
    });
  },
  computed: {
    modalTitle: function () {
      return this.$t('KW:mishnaShiurTitleWithMessageAndSpeaker', {
        masechta: this.book.name,
        chapter: this.mareiMekomos.shiurim.mishna_chapter,
        mishna: this.mareiMekomos.shiurim.mishna_number,
        message: this.mareiMekomos.shiurim.message,
        speaker: this.mareiMekomos.shiurim.lecturer.name,
      });
    },
    filteredMishnas: function () {
      this.filterMishna = null;
      var result = {};
      var chapters = this.book.chapters;

      for (var chapterKey in chapters) {
        result[chapterKey] = {};
        for (var mishnaKey in chapters[chapterKey]) {
          let temp = [];
          let shiurim = Object.values(chapters[chapterKey][mishnaKey]);

          shiurim.forEach(shiur => {
            if (!this.filtermagid || shiur.professor_id == this.filtermagid.value) {
              temp.push(shiur);
            }
          });

          if (temp.length > 0) {
            result[chapterKey][mishnaKey] = [];
            temp.forEach(t => result[chapterKey][mishnaKey].push(t));
          }
        }
      }

      return result;
    },
    chapterFilter: function () {
      if (!this.book || !this.book.chapters) return [];
      let chapters = JSON.parse(JSON.stringify(this.book.chapters));
      return Object.keys(chapters);
    },
    mishnaFilter: function () {
      if (!this.book || !this.filterChapter) return [];
      let chapters = JSON.parse(JSON.stringify(this.book.chapters));
      return Object.values(chapters[this.filterChapter]).map(c => c.mishna_number);
    },
  },
  watch: {
    $route: 'getData',
    bookRedirect: function (val, old) {
      if (old && old.value != val.value) {
        this.$router.push({
          name: 'mishna-masechta',
          params: { slug: val.value },
        });
      }
    },
    filterChapter: function (val, oldVal) {
      const scrollTo = scroller();
      if (val != null) {
        scrollTo('#mishna-' + val);
      }
    },
    filterMishna: function (val, oldVal) {
      const scrollTo = scroller();
      if (val != null) {
        scrollTo('#mishna-' + this.filterChapter + '-' + val);
      }
    },
  },
  methods: {
    track: function (url, vol = null) {
      var title = 'Masechta ' + this.book.name + ' vol. ' + vol + "with Mar'ei Mekomos";
      if (vol == null) {
        title = 'Entire Masechta ' + this.book.name + " with Mar'ei Mekomos";
      }
      this.downloadFileUsingURL(url);
      ga('send', 'event', 'Masechta', 'Download', title);
    },
    getData: function () {
      this.book = { name: null };
      this.loading = true;
      this.$http.get('/api/books/' + this.$route.params.slug).then(response => {
        this.book = response.data;
        this.bookRedirect = {
          label: this.isRTL ? this.book.name_hebrew : this.book.name + ' / ' + this.book.name_hebrew,
          value: this.book.url_key,
        };
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.masechta-page {
  .sponsors {
    .card-body {
      .btn-outline-secondary {
        border-color: $dark-blue;
        width: 400px;
        border-radius: 200px;
        @media (max-width: 576px) {
          width: 280px;
        }
        &:hover {
          background: $secondary;
          border-color: $secondary;
          color: $dark-blue;
        }
      }
    }
    .title {
      background: $light-blue;
      .dropdown-toggle {
        height: 50px;
        border-radius: 100px;
        padding: 0 20px;
        background: $white;
        font-weight: bold;
        font-size: 1rem;
        .selected-tag {
          color: $dark-blue;
        }
      }
    }
  }
}
</style>
